<template>
    <div class="empty-list">

        <svg class="add_date"><use xlink:href="#add_date"></use></svg>

        <p>You don’t have any dates for this trip yet!</p>

        <button type="button" @click="openModal()">
            <svg class="plus"><use xlink:href="#plus"></use></svg>
            Dates
        </button>

    </div>
</template>
<script>
export default {

    methods:{
        openModal() {
            eventBus.$emit('open-add-dates-to-list-dialog')
        }
    }

}
</script>
